import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reject, each, map, upperFirst, filter, sortBy } from 'lodash';
import Fa from 'react-fontawesome';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link, withRouter } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import {
  OverlayTrigger, Tooltip, Dropdown, MenuItem, NavItem, ControlLabel
} from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';

import ProgressBar from '../../../../components/progress-bar';
import DatetimeDisplay from '../../../../components/date-time-display';
import RunAutomationButton from '../../components/RunAutomationButton';
import TruVoiceDomainAuthorization from '../../../../components/tv-domain-authorizations';
import {
  fetchAllAutomationEmails,
  deleteAutomationEmail,
  cloneAutomationEmail,
  switchSystemAutomationEmail,
  orderAutomationEmails,
} from '../../SetupActions';
import {
  requestUpdateOrganization,
} from '../../../Admin/AdminActions';

import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import TestEmailButton from '../../components/TestSendEmailForm';

import styles from './styles.css';

/** a little function to help us with reordering the result */
const mutatedReorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};

class AutomationEmailIndex extends Component {
  constructor(props) {
    super(props);
    const { multiple_summary_per_opportunity: multipleSummaryPerOpp } = this.props.organization;
    this.state = {
      loading: false,
      error: null,
      settings: [],
      deleting: {}, // indexed by id
      duplicating: {}, // indexed by id
      confirmingId: null,
      openId: null,
      dragging: false,
      blinkId: null,
      multipleSummaryPerOpp,
    };
    this.deleteAutomation = this.deleteAutomation.bind(this);
    this.duplicateAutomation = this.duplicateAutomation.bind(this);
    this.switchDefaultAutomation = this.switchDefaultAutomation.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleMultipleSummaryPerOppToggle = this.handleMultipleSummaryPerOppToggle.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    this.setState({ loading: true }, () => {
      this.props.dispatch(fetchAllAutomationEmails(this.props.type, true))
        .then(
          ({ settings }) => {
            this.setState({ settings: this.cleanupList(settings), loading: false });
          },
          (error) => {
            this.setState({ error: error.data?.message || error.message, loading: false });
          },
        );
    });
  }

  cleanupList(settings) {
    // is_deleted
    // sort_order
    return sortBy(settings, [(s) => { return s.is_deleted ? 1 : 0 }, 'sort_order']);
  }
  

  onDragEnd(result) {
    const { source, destination } = result;
    if (!this.state.dragging && source.index !== destination.index) {
      const destinationList = [...this.state.settings];

      const draggedId = this.state.settings[source.index] ? this.state.settings[source.index]._id : null;

      mutatedReorder(
        destinationList,
        source.index,
        destination.index,
      );
      const positions = map(destinationList, '_id');
      this.setState({ dragging: true, draggedId: null }, () => {
        this.props.dispatch(orderAutomationEmails(this.props.type, { ids: positions }, true))
          .then(
            ({ settings }) => {
              this.setState({ settings: this.cleanupList(settings), dragging: false, draggedId });
            },
            () => {
              this.setState({ dragging: false, draggedId });
            },
          );
      });
    }
  }

  deleteAutomation(setting) {
    const { deleting, confirmingId } = this.state;
    if (confirmingId !== setting._id) {
      this.setState({ confirmingId: setting._id });
      return;
    }

    if (deleting[setting._id] === true) {
      return;
    }
    this.setState({ deleting: { ...deleting, [setting._id]: true } }, () => {
      this.props.dispatch(deleteAutomationEmail(this.props.type, setting._id))
        .then(
          () => {
            const newSettings = reject(this.state.settings, (s) => s._id === setting._id);
            this.setState({ confirmingId: null, settings: newSettings, deleting: { ...deleting, [setting._id]: false } });
          },
          () => {
            this.setState({ confirmingId: null, deleting: { ...deleting, [setting._id]: false } });
          },
        );
    });
  }

  handleToggle(open, e, s, openId) {
    if (open) {
      this.setState({ openId });
    } else if (s.source === 'rootClose') {
      this.setState({ openId: null, confirmingId: {} });
    }
  }

  handleMultipleSummaryPerOppToggle() {
    const multipleSummaryPerOpp = !this.state.multipleSummaryPerOpp;
    return this.props.dispatch(requestUpdateOrganization(this.props.organization._id, {
      multiple_summary_per_opportunity: multipleSummaryPerOpp
    }))
      .then(
        () => {
          this.setState({ multipleSummaryPerOpp });
        },
        (error) => {
          this.setState({ error: error.data?.message || error.message });
        },
      );
  }

  duplicateAutomation(setting) {
    const { duplicating } = this.state;
    if (duplicating[setting._id] === true) {
      return;
    }
    this.setState({ duplicating: { ...duplicating, [setting._id]: true } }, () => {
      this.props.dispatch(cloneAutomationEmail(this.props.type, setting._id))
        .then(
          (s) => {
            const newSettings = [...this.state.settings, s];
            this.setState({ openId: null, settings: newSettings, duplicating: { ...duplicating, [setting._id]: false } });
          },
          () => {
            this.setState({ openId: null, duplicating: { ...duplicating, [setting._id]: false } });
          },
        );
    });
  }

  switchDefaultAutomation(setting) {
    if (setting.is_system) {
      return;
    }

    this.props.dispatch(switchSystemAutomationEmail(this.props.type, setting._id))
      .then(
        (updatedSettings) => {
          const newSettings = this.state.settings?.map((oldSetting) => {
            return updatedSettings.find(updatedSetting => updatedSetting._id === oldSetting._id) || oldSetting;
          });
          this.setState({ openId: null, settings: newSettings });
        },
        (error) => {
          // TODO: Handle error
        },
      );
  }

  renderActions(setting) {
    const { deleting, duplicating, confirmingId, openId } = this.state;
    const isDeleting = deleting[setting._id] === true;
    const isDuplicating = duplicating[setting._id] === true;
    const isConfirming = confirmingId === setting._id;
    const isSystem = setting.is_system === true;


    let deleteBtn = null;
    if (isConfirming) {
      deleteBtn = (
        <span className="text-danger"><Fa name="trash" /> Sure?</span>
      );
    } else if (isDeleting) {
      deleteBtn = (
        <span className="text-danger"><Fa name="spinner" spin /> Deleting</span>
      );
    } else {
      deleteBtn = (
        <span><Fa name="trash" /> Delete</span>
      );
    }

    let duplicateBtn = null;
    if (isDuplicating) {
      duplicateBtn = (
        <span><Fa name="spinner" spin /> Duplicating</span>
      );
    } else {
      duplicateBtn = (
        <span><Fa name="copy" /> Duplicate</span>
      );
    }

    return (
      <Dropdown
        bsSize="sm"
        id={`settings-${setting._id}`}
        onToggle={(o, e, s) => {
          this.handleToggle(o, e, s, setting._id);
        }}
        open={(openId === setting._id)}
      >
        <Dropdown.Toggle>Actions</Dropdown.Toggle>
        <Dropdown.Menu className="pull-right">
          <MenuItem disabled={(isDeleting || isDuplicating)} eventKey={setting} onSelect={this.duplicateAutomation}>
            {duplicateBtn}
          </MenuItem>
          {!isSystem &&
            <MenuItem disabled={(isDeleting || isDuplicating)} eventKey={setting} onSelect={this.switchDefaultAutomation}>
              <span><Fa name="star" /> Set as Default</span>
            </MenuItem>
          }
          {!isSystem &&
            <MenuItem disabled={(isDeleting || isDuplicating)} eventKey={setting} onSelect={this.deleteAutomation}>
              {deleteBtn}
            </MenuItem>
          }
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  renderRow(setting, index, total) {
    const { dragging, draggedId } = this.state;
    const { type, location: { pathname } } = this.props;
    const isDeleted = setting.is_deleted === true;

    const tip = setting.is_system ? (
      <Tooltip id={`${setting._id}-system-automation`}>
        <div>System default {type} email</div>
      </Tooltip>
    ) : null;

    const blinking = draggedId === setting._id;

    let arrowName = 'arrows-v';
    if (total > 1) {
      if (index === 0) {
        arrowName = 'long-arrow-down';
      } else if (index === total - 1) {
        arrowName = 'long-arrow-up';
      }
    }
    if (dragging) {
      arrowName = 'spinner';
    }

    const render = (provided, snapshot) => {
      const attrs = (provided && snapshot) ? {
        ref: provided.innerRef,
        ...provided.draggableProps,
        className: `${snapshot.isDragging ? styles.dragging : null}`,
        style: provided.draggableProps.style,
      } : {};

      const icon = (<Fa name="star" className={setting.is_system ? 'text-warning' : 'text-muted'} />);

      const iconWithTip = tip ? 
        (
          <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={tip}>
            {icon}
          </OverlayTrigger>
        ) : icon;


      return (
        <tr {...attrs}>
          <td
            width="40"
            className="text-center"
            {...(provided ? provided.dragHandleProps : {})}
          >
            <Fa
              name={arrowName}
              spin={dragging}
              className={provided ? '' : 'invisible'}
            />
          </td>
          <td className="text-center" width="40">
            {!isDeleted && iconWithTip}
            {isDeleted && <Fa name="star" className="text-muted" />}
          </td>
          <td>
            <Link to={`${pathname}/${setting.source === 'account' ? 'accounts' : 'opportunities'}/${setting._id}`}>
              <span className={blinking ? 'animated flash' : ''}>
                <span className={isDeleted ? 'text-muted' : ''}>{setting.name}</span>
              </span>
            </Link>
          </td>
          <td>
            <span className="label label-default text-uppercase">{setting.source}</span>
          </td>
          <td>
            {!isDeleted && <span className={`label ${setting.enabled ? 'label-success' : 'label-danger'}`}>{setting.enabled ? 'YES' : 'NO'}</span>}
            {isDeleted && <span className="label label-danger">DELETED</span>}
          </td>
          <td>
            <DatetimeDisplay value={setting.updated_at} format="LLL" />
          </td>
          <td>
            {!isDeleted && this.renderActions(setting)}
          </td>
        </tr>
      );
    };

    if (isDeleted) {
      return render();
    }

    return (
      <Draggable draggableId={setting._id} key={setting._id} index={index}>
        {render}
      </Draggable>
    );
  }

  renderCreateNewButton() {
    const { type, location: { pathname } } = this.props;

    return (
      <Dropdown
        id="create-new-group"
      >
        <Dropdown.Toggle bsStyle="primary"><Fa name="plus" /> create a new {type} email</Dropdown.Toggle>
        <Dropdown.Menu className="pull-right">
          <LinkContainer to={`${pathname}/opportunities/new`}>
            <NavItem>Opportunity/Deal {upperFirst(type)} Email</NavItem>
          </LinkContainer>
          <LinkContainer to={`${pathname}/accounts/new`}>
            <NavItem>Account/Company {upperFirst(type)} Email</NavItem>
          </LinkContainer>
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  renderMultipleOppSummaryEmailsToggle() {
    const { multipleSummaryPerOpp } = this.state;
    return (
      <div>
        <ControlLabel>Allow Multiple per Opportunity:</ControlLabel>
        {' '}
        <Toggle
          onClick={this.handleMultipleSummaryPerOppToggle}
          on={<span>On</span>}
          off={<span>Off</span>}
          onstyle="success"
          size="xs"
          offstyle="danger"
          active={multipleSummaryPerOpp}
        />
      </div>
    );
  }

  renderTable() {
    const { settings } = this.state;
    const { type, emergencySettings } = this.props;

    const activeSettings = filter(settings, { is_deleted: false });
    const deletedSettings = filter(settings, { is_deleted: true });
    const hasDeletedRecords = deletedSettings.length > 0;

    return (
      <div>
        <div className="clearfix">
          <div className="pull-left" style={{ paddingTop: '5px' }}>
            {type === 'summary' && this.renderMultipleOppSummaryEmailsToggle()}
          </div>
          <div className="pull-right">
            {type === 'reminder' && emergencySettings && !emergencySettings.disabled && <RunAutomationButton title="Send Reminders Now" isReminder />}
            {type === 'reminder' && ' '}
            {this.renderCreateNewButton()}
          </div>
        </div>
        <p />
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Fragment>
            <table className={`table table-bordered table-condensed table-striped ${styles.table}`}>
              <thead>
                <tr>
                  <th width="40" />
                  <th colSpan="2">Current {upperFirst(type)} Emails:</th>
                  <th width="100">Source</th>
                  <th width="50">Enabled</th>
                  <th width="200">Last Modified</th>
                  <th width="80">Action</th>
                </tr>
              </thead>
              <Droppable droppableId="drop">
                {(provided, snapshot) => (
                  <tbody
                    ref={provided.innerRef}
                    className={snapshot.isDraggingOver ? styles.DraggingOver : null}
                  >
                    {activeSettings.map((s, index) => this.renderRow(s, index, activeSettings.length))}
                    {provided.placeholder}
                  </tbody>
                )}
              </Droppable>
              {hasDeletedRecords &&
                <thead>
                  <tr>
                    <th width="40" />
                    <th colSpan="6">Deleted {upperFirst(type)} Emails:</th>
                  </tr>
                </thead>
              }
              {hasDeletedRecords &&
                <tbody>
                  {deletedSettings.map((deletedSetting, index) => {
                    return this.renderRow(deletedSetting, index, deletedSettings.length);
                  })}
                </tbody>
              }
            </table>
          </Fragment>
        </DragDropContext>
        <p />
        <div className="clearfix">
          <div className="pull-left"><TruVoiceDomainAuthorization /></div>
          <div className="pull-left">&nbsp;&nbsp;<TestEmailButton>Send a Test Email</TestEmailButton></div>
        </div>
        <p />

      </div>
    );
  }

  render() {
    const { loading, error, settings } = this.state;
    const { type, location: { pathname } } = this.props;

    if (loading) {
      return (
        <div>
          <ProgressBar />
        </div>
      );
    }
    if (error !== null) {
      return (
        <div className="alert alert-danger">{error}</div>
      );
    }
    if (settings.length === 0) {
      return <div className="alert alert-danger">No automation email found. <Link to={`${pathname}/new`}>create a new {type} email</Link></div>;
    }
    return this.renderTable();
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

AutomationEmailIndex.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    multiple_summary_per_opportunity: PropTypes.bool.isRequired,
  }).isRequired,
  emergencySettings: PropTypes.shape({
    disabled: PropTypes.bool,
  }),
};
AutomationEmailIndex.defaultProps = {
  emergencySettings: null,
};
AutomationEmailIndex.contextTypes = {
};

export default withRouter(connect(mapStateToProps)(AutomationEmailIndex));
